<!-- BillingRuleDisplay.vue -->
<template>
    <div class="payment-container">
        <span class="payment-title">{{ $t('m.billingRate') }}</span>
        <div class="billing-rule-content" :class="{'list-style': isMoreThanOneLi}">
            <template v-if="defaultSubscriptionDetail">
                <pre class="detail">{{ defaultSubscriptionDetail }}</pre>
                <span v-if="billingRuleTaxText" class="billing-rule-item">
                    <span class="tax-hint">{{ billingRuleTaxText }}</span>
                </span>
            </template>
            <template v-else>
                <span class="billing-rule-item" v-for="(item, index) in formatBillingRule(billingRule)" :key="index">
                    <span v-if="item.price" class="price">{{ item.price }}</span>
                    <span v-if="item.priceTime" class="price-time">
                        <span class="price-time-slash">/</span>
                        <span class="price-time-label">{{ stripPriceTimeSlash(item.priceTime) }}</span>
                    </span>
                    <span v-if="item.message" class="message">{{ item.message }}</span>
                    <span v-if="item.li" class="li">{{ item.li }}</span>
                    <span v-if="item.taxHint" class="tax-hint">{{ item.taxHint }}</span>
                </span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        billingRule: {
            type: Object,
            required: true
        },
        defaultSubscriptionDetail: {
            type: String,
            default: ''
        }
    },
    computed: {
        billingRuleTaxText() {
            return this.getBillingRuleTaxText(this.billingRule);
        },
        isMoreThanOneLi() {
            // Move from main computed
            const filtered = Object.entries(this.billingRule).filter(([key, rule]) => {
                if (!rule) return false;
                const fields = ['low_limit', 'top_limit', 'pre_auth_amount'];
                const nonZeroCount = fields.filter(field => rule[field] !== 0).length;
                const isDepositValid = rule.deposit !== 0 && rule.maximum_rental_time !== 0;

                return nonZeroCount > 0 || isDepositValid;
            });

            return filtered.length > 1;
        }
    },
    methods: {
        stripPriceTimeSlash(value) {
            return String(value || '').replace(/^\/\s*/, '')
        },
    }
}
</script>
<style lang="scss">
@use '@/styles/variables.scss' as *;

.payment-container {
  margin-top: 20px;
  display: flex;
  gap: 9px;
  flex-direction: column;
  align-items: center;

  .payment-title {
    display: inline-block;
    width: $container-width;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.09px;
    letter-spacing: -0.2px;
  }
}

.billing-rule-content {
  width: $container-width;
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin: 0;
  padding: 15px;
  background: $background-white;
  border-radius: $border-radius;
  box-shadow: $shadow;

  .detail {
    white-space: pre-wrap;
    margin: 0;
    font-family: $font-family;
    line-height: 155%;
    color: $secondary-color;
    font-size: 14px;
  }
}

.billing-rule-item {
  line-height: 20.16px;
  font-size: 14px;
  color: $secondary-color;
  font-variant-numeric: tabular-nums;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;

  .price {
    font-family: $font-family-display;
    font-weight: 700;
    font-size: 20px;
    line-height: 35px;
    color: $text-color;
    letter-spacing: 0.02em;
  }

  .price-time {
    display: inline-flex;
    align-items: baseline;
    font-size: 12px;
    font-weight: 400;
    line-height: 1;
    color: $text-color;

    .price-time-slash {
      margin: 0 2px;
    }
  }

  .tax-hint {
    display: inline-block;
    font-size: 12px;
    line-height: 17px;
    color: #8a8a8a;
  }

  &.has-divider {
    position: relative;
    margin-top: 10px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: -9px;
      height: 1px;
      background: $border-color;
    }
  }
}

.list-style {
  .li,
  .tax-hint {
    width: 100%;
    position: relative;
    display: inline-block;
    padding-left: 14px;
    font-size: 12px;
    font-weight: 400;
    line-height: 17.28px;

    &::before {
      content: '';
      position: absolute;
      left: 1px;
      top: 6px;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background-color: $secondary-color;
    }
  }
}
</style>
